<template>
    <cms-modal unique="view-covid-vaccine" title="View Covid Vaccine Details" size="xl">
        <div class="row">
            <div class="col col-4">
                <form @submit.prevent="confirmUpdateCovidVaccine">

                    <div class="form-group form-row mb-1" :class="{'has-error': covidVaccineErrors.vaccine_brand_id}">
                        <label for="vaccine-brand" class="col col-sm-6 col-form-label font-weight-bolder">
                            Vaccine Brand:
                        </label>
                        <div class="col col-sm-11 offset-1 col-form-label p-0">
                            <select id="vaccine-brand" class="form-control form-control-xs" required
                                    :disabled="!editable"
                                    v-model="covidVaccine.vaccine_brand_id"
                            >
                                <option :value="null">--- Select Vaccine Brand ---</option>
                                <option v-for="vaccineBrandKey in vaccineBrandKeys" :key="vaccineBrandKey.id"
                                        :value="vaccineBrandKey.id"
                                >
                                    {{ vaccineBrandKey.name }}
                                </option>
                            </select>
                            <span class="help-block" v-if="covidVaccineErrors.vaccine_brand_id !== ''">
                              <small><strong>{{ covidVaccineErrors.vaccine_brand_id }}</strong></small>
                            </span>
                        </div>
                    </div>

                    <div class="form-group form-row mb-1" :class="{'has-error': covidVaccineErrors.inoculate_date}">
                        <label for="vaccine-date" class="col col-sm-6 col-form-label font-weight-bolder">
                            Inoculate Date:
                        </label>
                        <div class="col col-sm-11 offset-1 col-form-label p-0">
                            <input type="date" id="vaccine-date" v-if="editable"
                                   class="form-control form-control-xs"
                                   required
                                   v-model="covidVaccine.inoculate_date"
                            >
                            <input type="text" readonly v-else
                                   class="form-control form-control-xs"
                                   :value="covidVaccine.inoculate_date | moment('DD MMM YYYY')"
                            >
                            <span class="help-block" v-if="covidVaccineErrors.inoculate_date !== ''">
                              <small><strong>{{ covidVaccineErrors.inoculate_date }}</strong></small>
                            </span>
                        </div>
                    </div>



                    <div class="form-group form-row mb-1" :class="{'has-error': covidVaccineErrors.dose_2 }">
                        <label for="vaccine-dose2" class="col col-sm-12 col-form-label font-weight-bolder">
                            Dose 2 Required for this Brand?
                        </label>

                        <div class="col col-sm-11">
                            <div class="form-check d-block">
                                <label class="form-check-label text-left"
                                       for="vaccine-dose2"
                                >
                                  Check box, if YES:
<!--                                    {{ covidVaccine.dose_2 ? 'YES' : 'NO' }}-->
                                </label>
                              <input class="form-check-input mx-2 mt-1" type="checkbox" id="vaccine-dose2"
                                     :disabled="covidVaccine.is_booster || covidVaccine.vaccine_brand_id ===7 "
                                     v-model="covidVaccine.dose_2"
                              >
                            </div>
                            <span class="help-block" v-if="covidVaccineErrors.dose_2 !== ''">
                                <small><strong>{{ covidVaccineErrors.dose_2 }}</strong></small>
                            </span>
                        </div>
                    </div>

                    <div class="form-group form-row mb-1" :class="{'has-error': covidVaccineErrors.completion_date}"
                         v-if="covidVaccine.dose_2 || (!covidVaccine.dose_2 && editable)"
                    >
                        <label for="completion-date" class="col col-sm-10 col-form-label font-weight-bolder">
                            Completion Date (2nd Dose):
                        </label>
                        <div class="col col-sm-11 offset-1 col-form-label p-0">
                            <input type="date" id="completion-date" v-if="editable"
                                   :disabled="!covidVaccine.dose_2"
                                   required
                                   class="form-control form-control-xs"
                                   v-model="covidVaccine.completion_date"
                            >
                            <input type="text" readonly required v-else
                                   class="form-control form-control-xs"
                                   placeholder="Not Yet Completed"
                                   :value="covidVaccine.completion_date | moment('DD MMM YYYY')"
                            >
                            <span class="help-block" v-if="covidVaccineErrors.completion_date !== ''">
                              <small><strong>{{ covidVaccineErrors.completion_date }}</strong></small>
                            </span>
                        </div>
                    </div>

                    <div class="form-group form-row mb-1" :class="{'has-error': covidVaccineErrors.is_booster }">
                      <label for="vaccine-booster" class="col col-sm-12 col-form-label font-weight-bolder">
                        Is this Booster Shot?
                      </label>

                      <div class="col col-sm-11">
                        <div class="form-check d-block">
                          <label class="form-check-label text-left"
                                 for="vaccine-booster"
                          >
                            Check box, if YES:
                          </label>
                          <input class="form-check-input mx-2 mt-1" type="checkbox" id="vaccine-booster"
                                 :disabled="!editable || covidVaccine.dose_2"
                                 v-model="covidVaccine.is_booster"
                          >
                        </div>
                        <span class="help-block" v-if="covidVaccineErrors.is_booster !== ''">
                                  <small><strong>{{ covidVaccineErrors.is_booster }}</strong></small>
                              </span>
                      </div>
                    </div>

                    <div class="form-group form-row mb-1" :class="{'has-error': covidVaccineErrors.country_id}">
                        <label for="vaccine-country" class="col col-sm-6 col-form-label font-weight-bolder">
                            Administering Country:
                        </label>
                        <div class="col col-sm-11 offset-1 col-form-label p-0">
                            <select id="vaccine-country" class="form-control form-control-xs"
                                    required
                                    :disabled="!editable"
                                    v-model="covidVaccine.country_id"
                            >
                                <option :value="null">--- Select Country ---</option>
                                <option v-for="countryKey in countryKeys" :key="countryKey.id"
                                        :value="countryKey.id"
                                >
                                    {{ countryKey.name }}
                                </option>
                            </select>
                            <span class="help-block" v-if="covidVaccineErrors.country_id !== ''">
                              <small><strong>{{ covidVaccineErrors.country_id }}</strong></small>
                            </span>
                        </div>
                    </div>

                    <div class="form-group form-row mb-1" style="height: 60px;" :class="{'has-error': covidVaccineErrors.vaccineFile}">
                        <template v-if="editable">
                            <label for="vaccine-file" class="col col-sm-6 col-form-label font-weight-bolder">
                                Vaccine File:
                            </label>
                            <div class="col col-sm-11 offset-1 col-form-label p-0">
                                <input type="file" id="vaccine-file"
                                       class="form-control form-control-xs"
                                       accept="application/pdf"
                                       @change="updateFileFrame('vaccine')"
                                >
                                <span class="help-block" v-if="covidVaccineErrors.vaccineFile !== ''">
                                  <small><strong>{{ covidVaccineErrors.vaccineFile }}</strong></small>
                                </span>
                            </div>
                        </template>
                    </div>


                    <hr />
                  <template v-if="crew.active == 1 || isSystemAdmin">
                    <button type="submit" class="btn btn-warning btn-sm btn-xs mr-3 font-weight-bolder" v-if="!guest"
                            :key="'edit-covid-vaccine'"
                    >
                      <i class="fas fa-edit"></i>
                      {{ editable ? 'Update' : 'Edit' }}
                    </button>
                  </template>
                    <button class="btn btn-danger btn-sm btn-xs font-weight-bolder"
                            v-if="editable"
                            @click="cancelEdit"
                    >
                        <span class="fas fa-ban"></span>
                    </button>
                </form>


                <div class="align-bottom">
                    <div class="form-group form-row mb-1">
                        <label for="vaccine-created-by" class="col col-sm-4 col-form-label font-weight-bolder">
                            Uploaded By:
                        </label>
                        <div class="col col-sm-8 offset-4 col-form-label p-0">
                            <input type="text" id="vaccine-created-by"
                                   class="form-control form-control-xs" readonly
                                   :value="covidVaccine.createdBy"
                            >
                        </div>
                    </div>

                    <div class="form-group form-row mb-1">
                        <label for="vaccine-created-at" class="col col-sm-4 col-form-label font-weight-bolder">
                            Uploaded At:
                        </label>
                        <div class="col col-sm-8 col-form-label p-0">
                            <input type="text" id="vaccine-created-at"
                                   class="form-control form-control-xs" readonly
                                   :value="covidVaccine.createdAt"
                            >
                        </div>
                    </div>
                    <div class="form-group form-row mb-1">
                        <label for="vaccine-created-by" class="col col-sm-5 col-form-label font-weight-bolder">
                            Last Updated By:
                        </label>
                        <div class="col col-sm-7 col-form-label p-0">
                            <input type="text" id="vaccine-updated-by"
                                   class="form-control form-control-xs" readonly
                                   :value="covidVaccine.updatedBy"
                            >
                        </div>
                    </div>

                    <div class="form-group form-row mb-1">
                        <label for="vaccine-created-at" class="col col-sm-4 col-form-label font-weight-bolder">
                            Last Updated At:
                        </label>
                        <div class="col col-sm-8 col-form-label p-0">
                            <input type="text" id="vaccine-updated-at"
                                   class="form-control form-control-xs" readonly
                                   :value="covidVaccine.updatedAt"
                            >
                        </div>
                    </div>

                </div>


            </div>
            <div class="col col-8">
                <cms-file-frame
                    frame-id="new-vaccine"
                    :file-string="vaccineFileString"
                    :prompt="vaccineFilePrompt"
                    :frame-height="564"
                ></cms-file-frame>
            </div>
        </div>
    </cms-modal>
</template>

<script>
/* eslint-disable */
import { vueAppMixin } from "@/mixins/vueAppMixin";
import { formMixin } from "@/mixins/formMixin";
import { vesselMixin } from "@/mixins/vesselMixin";
import { gateMixin } from "@/mixins/gateMixin";
import { mapActions, mapGetters} from "vuex";
import { FileService } from "@/services/FileService";

import CmsFileFrame from "@/components/elements/CmsFileFrame";
import CmsModal from "@/components/elements/CmsModal";
import { FILE_SIZE_UPLOAD_LIMIT } from "@/services/ConstantService";

export default {
    name: "ViewCovidVaccine",

    mixins: [ vueAppMixin, formMixin, vesselMixin, gateMixin ],

    components: { CmsModal, CmsFileFrame },

    props: {
        viewCovidVaccine: {
            type: Object,
            default() {
                return {};
            }
        }
    },

    data() {
        return {
            covidVaccine: {},
            covidVaccineErrors: {},
            tempVaccineFileString: '',
            vaccineFileString: '',
            vaccineFilePrompt: '',
            editableFields: [
                'id',
                'inoculate_date',
                'completion_date',
                'country_id',
                'vaccine_brand_id',
            ],
            editable: false,
        }
    },

    methods: {
        ...mapActions([
            'getCovidVaccineFile',
            'updateCovidVaccine'
        ]),

        async confirmUpdateCovidVaccine() {
            if(this.editable) {
                if(await this.confirmUpdate()) {
                    let formData = new FormData();
                    this.editableFields.forEach(key => {
                        let value = this.covidVaccine[key] ? this.covidVaccine[key] : '';
                        if(value === '0000-00-00') value = '';
                        formData.append(key, value);
                    });
                    formData.append('dose_2', this.covidVaccine.dose_2 ? 1 : 0);
                    formData.append('is_booster', this.covidVaccine.is_booster ? 1 : 0);
                    let vaccineFile = document.getElementById('vaccine-file');
                    if(vaccineFile && vaccineFile.files[0]) {
                        formData.append('vaccineFile', vaccineFile.files[0]);
                    }
                    let updatedVaccine = await this.updateCovidVaccine(formData);
                    if(updatedVaccine) {
                        if(updatedVaccine.errors) {
                            this.covidVaccineErrors = updatedVaccine.errors;
                        } else {
                            this.successAlert('Covid Vaccine Record Successfully Updated', 'UPDATE');
                            document.getElementById('close-view-covid-vaccine').click();
                            this.covidVaccine = Object.assign({}, updatedVaccine);
                            this.covidVaccineErrors = {};
                            this.tempVaccineFileString = '';
                            this.vaccineFileString = '';
                        }
                    }
                }
            } else {
                this.editable = true;
                this.tempVaccineFileString = this.vaccineFileString;
            }
        },

        cancelEdit() {
            this.editable = false;
            this.covidVaccine = Object.assign({}, this.viewCovidVaccine);
            this.vaccineFileString = this.tempVaccineFileString;
        },

        async updateCovidVaccineFile(covidVaccineId) {
            this.vaccineFileString = await this.getCovidVaccineFile({ covidVaccineId: covidVaccineId });
        },

        updateFileFrame(inputId) {
            let input = document.getElementById(`${inputId}-file`);
            if (input.files && input.files[0]) {
                if(input.files[0].size > FILE_SIZE_UPLOAD_LIMIT) {
                    this.vaccineFilePrompt = 'FILE TOO LARGE';
                    this.vaccineFileString = '';
                    return;
                } else {
                    this.vaccineFilePrompt = '';
                    let vaccineFileString = '';
                    let reader = new FileReader();
                    reader.onload = e => vaccineFileString = e.target.result
                    reader.readAsDataURL(input.files[0]);
                    setTimeout(() => {
                        this.vaccineFileString = FileService.base64FileToBlobUrl(vaccineFileString);
                    }, 500);
                }
            } else {
                this.vaccineFileString = '';
            }
        },

    },

    computed: {
        ...mapGetters([
            'vaccineBrandKeys',
            'countryKeys',
        ])
    },

    watch: {
        'viewCovidVaccine'() {
            this.covidVaccine = Object.assign({}, this.viewCovidVaccine);
            this.updateCovidVaccineFile(this.covidVaccine.id);
            this.editable = false;
        },

        'covidVaccine.dose_2'() {
            this.covidVaccine.completion_date = ''
        },

        'covidVaccine.vaccine_brand_id'(){
          if(this.covidVaccine.vaccine_brand_id === 7){
            this.covidVaccine.dose_2=false;
          }
        }

    }

}
</script>

<style scoped>

</style>
